import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const TextField = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4 6.75H20C20.6904 6.75 21.25 7.30964 21.25 8V16C21.25 16.6904 20.6904 17.25 20 17.25H4C3.30964 17.25 2.75 16.6904 2.75 16V8C2.75 7.30964 3.30964 6.75 4 6.75Z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M9.75 3H12M12 3H14.25M12 3V21.5M12 21.5H9.75M12 21.5H14.25'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M4 6.75H20C20.6904 6.75 21.25 7.30964 21.25 8V16C21.25 16.6904 20.6904 17.25 20 17.25H4C3.30964 17.25 2.75 16.6904 2.75 16V8C2.75 7.30964 3.30964 6.75 4 6.75Z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M14.25 2.25C14.6642 2.25 15 2.58579 15 3C15 3.41421 14.6642 3.75 14.25 3.75H12.75V20.75H14.25C14.6642 20.75 15 21.0858 15 21.5C15 21.9142 14.6642 22.25 14.25 22.25H9.75C9.33579 22.25 9 21.9142 9 21.5C9 21.0858 9.33579 20.75 9.75 20.75H11.25V3.75H9.75C9.33579 3.75 9 3.41421 9 3C9 2.58579 9.33579 2.25 9.75 2.25H14.25Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
